// store/sessionMiddleware.ts
import type { Middleware } from '@reduxjs/toolkit';
import type { AppDispatch } from './index';

import { doSecurityLogin, doSecurityLogout } from './useSecurityStore';

import { doClientFetchAuthenticated, clientSlice } from './useClientStore';
import { promosSlice } from './usePromosStore';
import { shoppingCartSlice } from './useShoppingCartStore';
import { clearAnon } from './useAnonStore';

/**
 * Minimal auth lifecycle watcher:
 * - On login.fulfilled → clear anon session, fetch client, promos, cart
 * - On logout.fulfilled → reset client, promos, cart slices
 */
export const sessionMiddleware: Middleware = (api) => (next) => (action) => {
  const result = next(action);

  // Cast so TS accepts thunks here
  const dispatch = api.dispatch as AppDispatch;

  if (doSecurityLogin.fulfilled.match(action)) {
    // clear anon id when user logs in
    dispatch(clearAnon());
    dispatch(doClientFetchAuthenticated());
    dispatch(promosSlice.actions.reset());
    dispatch(shoppingCartSlice.actions.reset());
  }

  if (doSecurityLogout.fulfilled.match(action)) {
    dispatch(clientSlice.actions.reset());
    dispatch(promosSlice.actions.reset());
    dispatch(shoppingCartSlice.actions.reset());
  }

  return result;
};
